export default __webpack_public_path__ + "static/media/National-Competition-2022.7cb4af33.pdf";